import { render } from "./DashboardInstanceSelector.vue?vue&type=template&id=2a8754e2&scoped=true"
import script from "./DashboardInstanceSelector.vue?vue&type=script&lang=js"
export * from "./DashboardInstanceSelector.vue?vue&type=script&lang=js"

import "./DashboardInstanceSelector.vue?vue&type=style&index=0&id=2a8754e2&lang=scss&scoped=true"

import exportComponent from "/home/forge/deployments/control-center.conneqt.io/new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8754e2"]])

export default __exports__